export const DISPATCH_TIME = "Dispatch Time"
export const ROUTE_ID = "Route ID"
export const LOCATION = "Location"
export const STATUS = "Status"
export const STAGE_TIME = "Stage Time"
export const CARTS = "Carts"
export const DRIVER = "Driver"
export const ROUTE_TYPE = "Type"
export const PROGRESS = "Progress"
export const ASSOCIATE = "Associate"
export const DURATION = "Duration"


export const ROUTE_VIEW_TABLE_COLUMNS = [
    DISPATCH_TIME,
    ROUTE_ID,
    LOCATION,
    STATUS,
    STAGE_TIME,
    CARTS,
    DRIVER,
    ROUTE_TYPE,
]

export const AR_SSD_ROUTE_VIEW_TABLE_COLUMNS = [
    DISPATCH_TIME,
    ROUTE_ID,
    LOCATION,
    STATUS,
    PROGRESS,
    ASSOCIATE,
    STAGE_TIME,
    DURATION,
    ROUTE_TYPE,
]


// WEBPACK FOOTER //
// ./src/components/routeStageStatus/RouteViewTableColumns.js